import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
    selector: 'ng-template[appNamedTemplate]',
    standalone: false
})
export class NamedTemplateDirective {
  @Input() appNamedTemplate: string;

  constructor(public template: TemplateRef<any>) {
  }
}
